<script setup lang="ts">
import { IconPicker } from '#layers/ui';

defineProps<{ placeholder?: string }>();

const displayName = defineModel<string | null>('displayName', {
	required: true,
	set: (value) => value === '' ? null : value,
});
const icon = defineModel<string | null>('icon', { required: true });
const iconColor = defineModel<string | null>('iconColor', { required: true });
</script>

<template>
	<span class="flex items-stretch gap-2">
		<IconPicker
			v-model="icon"
			v-model:color="iconColor"
			pick-color
			variant="soft"
			spacing="comfortable"
		/>
		<DInput
			v-model="displayName"
			:placeholder
			block
		/>
	</span>
</template>
